import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { MdSecurity } from 'react-icons/md';
import { LuShieldAlert } from 'react-icons/lu';
import { LoadingSpinner } from 'components/common';
import { fetchMyAuditLogs } from 'components/app/authorization/audit-log/auditLogApi';
import { deviceLabel, eventLabel } from 'components/app/authorization/audit-log/auditLogLabels';

// The sign-ins on my own account. Seeing a sign-in you do not recognise is how
// a stolen password is usually noticed — the person is the best detector.
const MySignInActivity = () => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    let active = true;
    fetchMyAuditLogs({ perPage: 10 })
      .then((result) => { if (active) setRows(result.rows); })
      .catch(() => { if (active) setRows([]); });
    return () => { active = false; };
  }, []);

  return (
    <div className="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-shadow-sm tw-overflow-hidden">
      <div className="tw-flex tw-items-center tw-gap-2 tw-px-5 tw-py-3.5 tw-border-b tw-border-slate-100">
        <MdSecurity size={16} className="tw-text-primary-400" />
        <span className="tw-text-sm tw-font-semibold tw-text-slate-700">Recent sign-in activity</span>
      </div>
      <div className="tw-px-5 tw-py-2">
        {rows === null && <LoadingSpinner />}
        {rows?.length === 0 && <p className="tw-text-sm tw-text-slate-500 tw-my-2">No activity yet.</p>}
        {rows?.length > 0 && (
          <ul className="tw-m-0 tw-p-0 tw-list-none tw-divide-y tw-divide-slate-100">
            {rows.map((row) => (
              <li key={row.id} className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2 tw-py-2 tw-text-sm">
                <span className={`tw-flex tw-items-center tw-gap-1.5 ${row.outcome === 'failure' ? 'tw-text-red-700' : 'tw-text-slate-700'}`}>
                  {row.outcome === 'failure' && <LuShieldAlert size={14} aria-label="Failed" />}
                  {eventLabel(row.action)}
                  {row.impersonator && <span className="tw-text-xs tw-text-amber-700">by {row.impersonator.name}</span>}
                </span>
                <span className="tw-text-xs tw-text-slate-500">
                  {[dayjs(row.created_at).format('DD-MMM-YYYY HH:mm'), row.remote_address, deviceLabel(row.user_agent)]
                    .filter(Boolean).join(' · ')}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default MySignInActivity;
